import { __rest } from 'tslib';
import React, { PureComponent } from 'react';
import Badge from '@tencent/dui/lib/components/Badge';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import styles from './toolbar-button.less.js';
import { getTooltipWithShortCut } from '../../tooltip/tooltip-with-shortcut.js';
import { isTooltipConfig } from '../../tooltip/tooltip-config.js';
import { evaluate } from '../../../controllers/base/evaluate.js';
import { ToolbarContext } from '../components/toolbar-context.js';
import { calculateNodeTotalWidth } from '../utils/node-util.js';

class ButtonWrapper extends PureComponent {
    constructor() {
        super(...arguments);
        this.wrapper = React.createRef();
        this.width = 0;
        this.state = {
            showTooltip: this.props.showToolTip,
        };
    }
    componentDidMount() {
        var _a, _b;
        const rootDom = (_a = this.wrapper.current) === null || _a === void 0 ? void 0 : _a.rootRef;
        if (rootDom === null || rootDom === void 0 ? void 0 : rootDom.current) {
            this.width = calculateNodeTotalWidth(rootDom.current.parentElement, true);
            (_b = this.context.shrinkManager) === null || _b === void 0 ? void 0 : _b.updateWidth(this.props.item.name, this.width);
        }
    }
    componentWillUnmount() {
        var _a;
        (_a = this.context.shrinkManager) === null || _a === void 0 ? void 0 : _a.withdraw(this.props.item.name);
    }
    componentDidUpdate() {
        var _a, _b;
        const rootDom = (_a = this.wrapper.current) === null || _a === void 0 ? void 0 : _a.rootRef;
        if (rootDom === null || rootDom === void 0 ? void 0 : rootDom.current) {
            const width = calculateNodeTotalWidth(rootDom.current.parentElement, true);
            if (width !== this.width) {
                this.width = width;
                (_b = this.context.shrinkManager) === null || _b === void 0 ? void 0 : _b.updateWidth(this.props.item.name, this.width);
            }
        }
    }
    render() {
        const { badge, className, 
        // hasArrow,
        item, placement = 'bottom', } = this.props;
        const style = {};
        if (this.props.checkColor) {
            style.background = this.props.checkColor;
        }
        const content = React.createElement(Badge, { dot: badge, className: styles['toolbar-badge'], style: {
                width: 6,
                height: 6,
                top: 0,
                // right: hasArrow ? 10 : 0,
                // 新设计要求: badge 左侧和箭头右侧在同一竖直线上
                right: 0,
                border: 'none',
            }, key: "button-with-badge" }, this.props.children);
        const tooltipWithShortCut = getTooltipWithShortCut(item);
        const tooltip = tooltipWithShortCut !== null && tooltipWithShortCut !== void 0 ? tooltipWithShortCut : evaluate(this.props.item.tooltip, '');
        let tooltipContent;
        let overrideTooltipConfig;
        if (isTooltipConfig(tooltip)) {
            const { content: customContent } = tooltip, rest = __rest(tooltip, ["content"]);
            tooltipContent = customContent;
            overrideTooltipConfig = rest;
        }
        else {
            tooltipContent = tooltip;
        }
        return React.createElement(Tooltip, Object.assign({ disabled: !tooltip, overlayHoverable: false, alignment: "center", hoverDelay: 200, placement: placement, className: className, title: tooltipContent }, overrideTooltipConfig, { ref: this.wrapper, 
            // ??? 待查 ↓
            overlayClassName: this.props.overlayClassName, visible: this.props.showToolTip, style: Object.assign({ verticalAlign: 'bottom', width: 'max-content' }, style), onVisibleChange: (visible) => {
                var _a, _b, _c;
                // eslint-disable-next-line @typescript-eslint/dot-notation
                (_a = tooltip === null || tooltip === void 0 ? void 0 : tooltip['onVisibleChange']) === null || _a === void 0 ? void 0 : _a.call(tooltip, visible);
                (_c = (_b = this.props).onVisibleChange) === null || _c === void 0 ? void 0 : _c.call(_b, visible);
            } }), content);
    }
}
ButtonWrapper.contextType = ToolbarContext;

export { ButtonWrapper };
//# sourceMappingURL=button-wrapper.js.map
